import { Component, ViewChild } from '@angular/core';
import { ModalController, Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/auth/login/login';
import { DbContext } from '../services/data/dbcontext.service';
import { ConfirmationModalComponent } from '../pages/daily-log/confirmation-modal/confirmation-modal.component';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AppConfig } from './app.config';
import { NavHelperService } from '../services/nav/nav-helper.service';
import { VesselContextService } from '../services/vessel/vessel-context.service';
import { SupportVideoPlayerPage } from '../pages/support/support-video-player/support-video-player';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  config = AppConfig.settings;
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  rootParams: any;
  showAdminButtons: boolean;
  environmentLabel: string = this.config.tag;
  versionNumber: string = this.config.version;
  pages: Array<{ title: string, component: any }>;
  sidebarCollapsed: boolean;
  showSupportPanel: boolean;
  private hashChangeHandler: () => void;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public dbcontext: DbContext,
    public modalController: ModalController,
    private http: HttpClient,
    private navHelperService: NavHelperService,
    private vesselContext: VesselContextService
  ) {
    this.setInitialRootPage();
    this.initializeApp();

    // used for an example of ngFor and navigation
    this.pages = [
      {title: 'Home', component: LoginPage}
    ];

    // environment is also double checked on api when pressing these
    this.showAdminButtons = this.config.tag.toLowerCase().includes('local')
      || this.config.tag.toLowerCase().includes('test')
      || this.config.tag.toLowerCase().includes('uat')
      || this.config.tag.toLowerCase().includes('inter');
    this.navHelperService.currentSidebarCollapsed.subscribe(sidebarCollapsed => {
      this.sidebarCollapsed = sidebarCollapsed;
    });

    this.hashChangeHandler = () => this.updateSupportPanelVisibility();
    window.addEventListener('hashchange', this.hashChangeHandler);
    this.updateSupportPanelVisibility();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      if (!this.isSupportVideoPlayerRoute()) {
        await this.vesselContext.init();
      }
    });
  }

  backupVesselDatabase() {
    const confirmationModal = this.modalController.create(ConfirmationModalComponent, {
      message: 'Confirm backup of vessel app data',
      trueText: 'Confirm',
      falseText: 'Cancel',
      showButtons: true
    }, {cssClass: 'daily-log-modal-one-line'});

    confirmationModal.onDidDismiss(async data => {
      if (data && data.choice) {
        this.backupVesselDatabaseApiCall().then(res => {
          res.subscribe(result => {
            const backupCompleteModal = this.modalController.create(ConfirmationModalComponent, {
              message: 'Backup Complete',
              trueText: 'Ok',
              confirmationOnly: true,
              showButtons: true
            }, {cssClass: 'daily-log-modal-one-line'});

            backupCompleteModal.present();
          });
        });
      }
    });

    confirmationModal.present();
  }

  deleteAllData() {
    const confirmationModal = this.modalController.create(ConfirmationModalComponent, {
      message: 'Are you sure you want to reset all Data',
      trueText: 'Confirm',
      falseText: 'Cancel',
      showButtons: true
    }, {cssClass: 'daily-log-modal-one-line'});

    confirmationModal.onDidDismiss(async data => {
      if (data && data.choice) {
        localStorage.clear();
        this.dbcontext.dropAllTables();
        this.deleteDataApiCall().then(res => {
          res.subscribe(result => {
            location.reload();
          });
        });
      }
    });

    confirmationModal.present();
  }

  async deleteDataApiCall(): Promise<Observable<string>> {
    const url = `${this.config.apiUrl}api/appdata/resetalldata`;

    return this.http.get<string>(url);
  }

  async backupVesselDatabaseApiCall(): Promise<Observable<string>> {
    const url = `${this.config.apiUrl}api/appdata/backupvesseldatabase`;

    return this.http.get<string>(url);
  }

  private updateSupportPanelVisibility() {
    this.showSupportPanel = !this.isSupportVideoPlayerRoute();
  }

  private setInitialRootPage() {
    const videoRoute = this.getSupportVideoPlayerRoute();

    if (videoRoute.videoId) {
      this.rootPage = SupportVideoPlayerPage;
      this.rootParams = videoRoute;
      return;
    }

    this.rootPage = LoginPage;
    this.rootParams = null;
  }

  private isSupportVideoPlayerRoute(): boolean {
    return !!this.getSupportVideoPlayerRoute().videoId;
  }

  private getSupportVideoPlayerRoute(): any {
    const match = window.location.hash.match(/^#\/support-video-player\/([^?&/]+)(?:\?(.+))?/);

    if (!match) {
      return {};
    }

    const params = this.parseQueryString(match[2] || '');
    params.videoId = decodeURIComponent(match[1]);

    return params;
  }

  private parseQueryString(queryString: string): any {
    const params: any = {};

    queryString
      .split('&')
      .filter(part => !!part)
      .forEach(part => {
        const keyValue = part.split('=');
        params[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1] || '');
      });

    return params;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts